import { render, staticRenderFns } from "./archive_rule.vue?vue&type=template&id=711b9d48&"
import script from "./archive_rule.vue?vue&type=script&lang=js&"
export * from "./archive_rule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports